import React from 'react';

interface AvatarProps {
  seatIndex: number;
  size?: number;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ seatIndex, size = 40, className = '' }) => {
  const colorIndex = seatIndex % 8;
  const isSpecial = colorIndex === 7; // Seat 7 has a different style

  return (
    <div
      className={`relative ${className}`}
      style={{ width: size, height: size }}
    >
      {/* Face */}
      <img
        src={`/avatars/face-${colorIndex + 1}.svg`}
        alt=""
        className="absolute inset-0 w-full h-full"
      />
      {/* Hair */}
      <img
        src={isSpecial ? '/avatars/hair-8.svg' : '/avatars/hair.svg'}
        alt=""
        className="absolute inset-0 w-full h-full"
      />
      {/* Left Eye */}
      <img
        src={isSpecial ? '/avatars/eye-left-8.svg' : '/avatars/eye-left.svg'}
        alt=""
        className="absolute"
        style={{
          width: '26%',
          height: '26%',
          left: '14%',
          top: '28%',
        }}
      />
      {/* Right Eye */}
      <img
        src={isSpecial ? '/avatars/eye-right-8.svg' : '/avatars/eye-right.svg'}
        alt=""
        className="absolute"
        style={{
          width: '26%',
          height: '26%',
          left: '60%',
          top: '28%',
        }}
      />
      {/* Nose */}
      {isSpecial ? (
        <>
          <img
            src="/avatars/nose-dot.svg"
            alt=""
            className="absolute"
            style={{
              width: '4%',
              height: '13%',
              left: '44%',
              top: '54%',
            }}
          />
          <img
            src="/avatars/nose-dot.svg"
            alt=""
            className="absolute"
            style={{
              width: '4%',
              height: '13%',
              left: '52%',
              top: '54%',
            }}
          />
        </>
      ) : (
        <img
          src="/avatars/nose.svg"
          alt=""
          className="absolute"
          style={{
            width: '13%',
            height: '13%',
            left: '44%',
            top: '54%',
          }}
        />
      )}
      {/* Mouth */}
      <img
        src={isSpecial ? '/avatars/mouth-8.svg' : '/avatars/mouth.svg'}
        alt=""
        className="absolute"
        style={{
          width: '52%',
          height: '25%',
          left: '24%',
          top: '58%',
        }}
      />
    </div>
  );
};

export default Avatar;
